module.exports = __webpack_public_path__ + "static/media/logo-hubtec.775ea872.svg";